exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.title h4[data-v-479c7866] {\n    font-size: 15px !important;\n    font-weight: 700;\n    margin-bottom: 0;\n    margin-top: 0;\n}\n", ""]);

// exports
